import { actions } from './actions';

export const theme = {
  state: {
    themes: {},
    theme: {
      title: '旅遊文章載入中...',
      contents: [
        {
          reference: {
            content:
              '沒有一定的參觀方式，也不需要任何門票，無意中在臺南散步見到了一座廟宇，只要有欣賞跟尊重的心意，都歡迎走進來看看。臺南人為了把最好獻給護佑鄉里的神明，廟宇的每一處幾乎沒有留白，都被填滿了華麗的工藝。你可以拉遠看、靠近看、低頭看、抬頭看，每間廟宇都有百個以上的圖樣造型值得慢慢欣賞，看累了可以在廟兩旁的板條凳上休憩一下。欣賞完廟宇之美後也建議到附近的景點與小店去走一走，吃個肉圓買包蜜餞，或再前往另一座鄰近的美廟，讓一場臺南式的廟宇小旅行更加圓滿。'
          }
        }
      ]
    }
  },
  getters: {
    themes(state) {
      return state.themes;
    },
    theme(state) {
      return state.theme;
    },
  },
  mutations: {
    setThemes(state, payload) {
      state.themes = payload;
    },
    setTheme(state, payload) {
      state.theme = payload;
    },
    // 收合段落
    toggleThemeGuide(state, guideIndex) {
      state.theme.theme_guides[guideIndex].ariaExpanded = !state.theme.theme_guides[guideIndex].ariaExpanded;
    }
  },
  actions,
};
